const LegalNameNotice = () => (
  <div className="p-4 rounded-xl bg-[#E8F2F4] border border-[#153e46]/15 text-xs text-[#153e46] leading-relaxed">
    This is the first and last name you submitted when you signed up. If this is
    correct leave it or correct it now because it has to match the name on your
    govt issued id so that your id verification can be successful.
  </div>
);

export default LegalNameNotice;
